import React, { useEffect, useState } from 'react';
import { Checkbox, Collapse, CollapseProps, Table } from 'antd';
import { NameOf } from 'src/utils';
import { ColumnProps } from 'antd/lib/table';
import TableColumnBuilder from 'src/utils/core/TableColumnBuilder';
import { FilterValue } from 'antd/lib/table/interface';
import CRMLookupDTO from 'src/models/generated/CRMLookupDTO';

export interface AccountDetailTableProps {
  data?: CRMLookupDTO[];
  loading?: boolean;
}

const AccountDetailsTable: React.FC<AccountDetailTableProps> = (props) => {
  const [filteredInfo, setFilteredInfo] = useState<Record<string, FilterValue | null>>({});
  const [openKeys, setOpenKeys] = useState<Parameters<Required<CollapseProps>['onChange']>[0]>(['1']);
  const tableData = props.data ?? [];

  useEffect(() => {
    if (props.loading) {
      setFilteredInfo({});
    }
  }, [props.loading]);

  const tableColumns: ColumnProps<CRMLookupDTO>[] = [
    TableColumnBuilder.Create<CRMLookupDTO>('accountNumber', 'Account Number')
      .Width(150)
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<CRMLookupDTO>('accountPOS', 'POS')
      .Width(100)
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<CRMLookupDTO>('accountName', 'Account Name')
      .Width(400)
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<CRMLookupDTO>('accountPhone', 'Account Phone')
      .Width(150)
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<CRMLookupDTO>('accountAddress', 'Billing Address')
      // .Width(500)
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<CRMLookupDTO>('accountAppEnabled', 'App Enabled')
      .Width(100)
      .Align('center')
      .AddRenderer('Custom', (val) => <Checkbox disabled checked={val}></Checkbox>)
      .FilteredValue(filteredInfo)
      .Build(),
  ];

  return <div className='account-detail-table table-section'>
    <Collapse collapsible='header' ghost activeKey={openKeys} onChange={setOpenKeys}>
      <Collapse.Panel key={1} header={<h3 className='table-title'>Account Detail</h3>}>
        <Table
          rowKey={NameOf<CRMLookupDTO>('accountNumber')}
          className='condensed-table striped-table borderless-table'
          rowClassName={(record, index) => (index % 2 ? 'striped-row' : '')}
          loading={props.loading}
          pagination={false}
          columns={tableColumns}
          dataSource={tableData}
          onChange={(_, filters) => { setFilteredInfo(filters); }}
        />
      </Collapse.Panel>
    </Collapse>
  </div>;
};

export default AccountDetailsTable;
